module.exports = __webpack_public_path__ + "static/media/PlumGuide.49962f7e.ico";